export default __webpack_public_path__ + "static/media/ELK.61a34db1.png";